module.exports = __webpack_public_path__ + "static/media/d2.8a77253b.svg";